// extracted by mini-css-extract-plugin
module.exports = {"starStatsContainer":"StarStats_starStatsContainer__3bv99","starStatsIcon":"StarStats_starStatsIcon__3WHpO","starStatsStat":"StarStats_starStatsStat__3nEGd"};